import {Component, EventEmitter, Input, Output, Optional} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-button-save',
    template: '<button class="btn btn-info" [disabled]="disable" (click)="onConfirm()"> <i class="fa fa-floppy-o"></i> {{ title | translate }}</button>',
    standalone: false
})
export class ButtonSaveComponent {

  constructor(@Optional() public modalRef: BsModalRef){};

  @Input() disable: boolean;

  @Input() title = 'save';

  @Output() confirm = new EventEmitter();

  onConfirm() {
    this.confirm.emit(this.modalRef);
  }
}